import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

import EntityInboxList from "../../../Chat/ListView/EntityInboxList";

interface Props {
  contract: ContractDto;
}

export default function InboxTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={1} sx={{ p: 0, borderRadius: "inherit" }}>
        <EntityInboxList
          displayProps={{
            header: false,
            viewVariant: ViewVariant.Tab,
          }}
          defaultValues={{
            contractId: contract.id!,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
